module.exports = __webpack_public_path__ + "static/media/mask-alt.471b942f.png";